/* scrolling-promotion.js — robusto contra tiempos de montaje */
(function () {
  const NS = "[m-scrolling-promotion]";
  const log = (...a) => console.log(NS, ...a);
  const warn = (...a) => console.warn(NS, ...a);
  const err = (...a) => console.error(NS, ...a);

  function ready(el, cb, { timeout = 3000 } = {}) {
    // Llama cb cuando exista .m-promotion dentro de el
    const start = performance.now();
    const check = () => {
      const strip = el.querySelector(".m-promotion");
      if (strip) return cb(strip);
      if (performance.now() - start > timeout) {
        warn("Timeout esperando .m-promotion", el);
        return;
      }
      requestAnimationFrame(check);
    };

    // Por si el DOM entra después vía mutaciones
    const mo = new MutationObserver(() => {
      const strip = el.querySelector(".m-promotion");
      if (strip) {
        mo.disconnect();
        cb(strip);
      }
    });
    mo.observe(el, { childList: true, subtree: true });

    requestAnimationFrame(check);
  }

  function initInstance(el, strip) {
    if (!el || !strip) return;
    if (el.hasAttribute("data-scrolling-enhanced")) {
      log("skip: ya inicializado", el);
      return;
    }
    el.setAttribute("data-scrolling-enhanced", "true");
    log("initInstance()", { childElementCount: el.childElementCount });

    // Clase que dispara la animación (el CSS debe definir la @keyframes)
    strip.classList.add("m-promotion--animated");

    // Clonado (si no hay clones aún)
    const clones = Array.from(el.children).filter(n => n !== strip);
    if (clones.length === 0) {
      for (let i = 0; i < 10; i++) {
        const c = strip.cloneNode(true);
        c.setAttribute("aria-hidden", "true");
        el.appendChild(c);
      }
      log("clonado x10");
    } else {
      log("ya tenía clones:", clones.length);
    }

    // Pausa/Reanuda por visibilidad
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) el.classList.remove("m-scrolling-promotion--paused");
        else el.classList.add("m-scrolling-promotion--paused");
      });
    }, { rootMargin: "0px 0px 50px 0px" });
    io.observe(el);

    // Debug CSS
    setTimeout(() => {
      const cs = getComputedStyle(strip);
      log("CSS animación", {
        animationName: cs.animationName,
        animationDuration: cs.animationDuration,
        animationPlayState: cs.animationPlayState
      });
      if (!cs.animationName || cs.animationName === "none") {
        warn("No se detecta animación en .m-promotion--animated (revisar CSS @keyframes y selectores)");
      }
    }, 50);
  }

  function bootstrap(el) {
    // Espera a que exista .m-promotion y luego inicializa
    ready(el, (strip) => initInstance(el, strip));
  }

  // ---- Custom Element (solo si no existe)
  if (!customElements.get("m-scrolling-promotion")) {
    class MScrollingPromotion extends HTMLElement {
      constructor() { super(); log("constructor()"); }
      connectedCallback() {
        log("connectedCallback()");
        bootstrap(this);
      }
    }
    customElements.define("m-scrolling-promotion", MScrollingPromotion);
    log("custom element definido por este archivo.");
  } else {
    log("CE ya existía; inicializo con bootstrap()");
  }

  // Inicializa los existentes en DOM (por si el CE ya estaba)
  document.querySelectorAll("m-scrolling-promotion").forEach(bootstrap);

  // Theme Editor: reinit cuando recargan secciones
  document.addEventListener("shopify:section:load", (ev) => {
    const root = ev?.target;
    if (root?.querySelectorAll) {
      root.querySelectorAll("m-scrolling-promotion").forEach(bootstrap);
    }
  });
})();
